/** Tiny DOM helpers; HUD updates go through `setText`/`toggle` which skip unchanged writes. */

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Record<string, string> = {}, children: (Node | string)[] = []): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === "class") e.className = v;
    else e.setAttribute(k, v);
  }
  for (const c of children) e.append(c);
  return e;
}

export function byId<T extends HTMLElement>(root: ParentNode, id: string, type: new () => T): T {
  const e = root.querySelector(`[data-ref="${id}"]`);
  if (!(e instanceof type)) throw new Error(`missing element ${id}`);
  return e;
}

export function setText(e: HTMLElement, text: string): void {
  if (e.textContent !== text) e.textContent = text;
}

export function toggle(e: HTMLElement, visible: boolean): void {
  if (e.hidden === visible) e.hidden = !visible;
}

export function setStyle(e: HTMLElement, prop: "width" | "transform" | "left" | "top" | "color" | "background" | "--p", value: string): void {
  if (prop === "--p") {
    if (e.style.getPropertyValue("--p") !== value) e.style.setProperty("--p", value);
    return;
  }
  if (e.style[prop] !== value) e.style[prop] = value;
}
